module.exports = "/_next/static/images/AiAdoptionGraph-536435d5d4a314546beefb64cc9ca5d4.png";